import type { DrillDownFilterDensity } from './DrillDownFilter.types'

export interface IDrillDownFilterLayout {
  density: DrillDownFilterDensity
  footerLayout: 'end' | 'fill'
  autoFocusSearch: boolean
  showRootHeader: boolean
}

export const DESKTOP_LAYOUT: IDrillDownFilterLayout = {
  density: 'default',
  footerLayout: 'end',
  autoFocusSearch: true,
  showRootHeader: false,
}

export const MOBILE_LAYOUT: IDrillDownFilterLayout = {
  density: 'comfortable',
  footerLayout: 'fill',
  autoFocusSearch: false,
  showRootHeader: true,
}
